import { Box } from '@mui/material';
import General from './general';
import Spaces from './spaces';
import Flows from './flows';
import Sessions from './sessions';
import Actors from './contributors/actors';
import Crew from './contributors/crew';
import Features from './features.tsx';
import EventMode from './event-mode';
import { useState } from 'react';
import EditSettingsModal, { type MenuButtonType as TabMenuButtonType } from './settings/edit-settings.modal';
import EventSubscriptionPlanWidget from '@/components/events/plan/event-subscription-plan-widget';
import { useEventStore } from '@/state/stores/use-event-store';

export const DashboardTab = ({
  setActivateContributorInlineAdding,
}: {
  setActivateContributorInlineAdding: (value: boolean) => void;
}) => {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [menuSelected, setMenuSelected] = useState<TabMenuButtonType>('general');
  const [initialDayIndex, setInitialDayIndex] = useState<number | undefined>(undefined);

  const openSettingsWithDayTiming = (dayIndex: number) => {
    setMenuSelected('schedule');
    setInitialDayIndex(dayIndex);
    setSettingsOpen(true);
  };

  const openSettings = () => {
    setMenuSelected('general');
    setInitialDayIndex(undefined);
    setSettingsOpen(true);
  };

  const openPreselectedSettings = (menu: TabMenuButtonType) => {
    setMenuSelected(menu);
    setInitialDayIndex(undefined);
    setSettingsOpen(true);
  };

  const multiFlow = useEventStore((s) => s.event?.multiFlow === true);

  return (
    <>
      <Box data-testid="event-dashboard" sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', md: 'row' } }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <EventMode />
          <General openSettingsWithDayTiming={openSettingsWithDayTiming} openSettings={openSettings} />
          <Spaces openSettings={() => openPreselectedSettings('spaces')} />
          <Flows />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          {multiFlow ? <EventSubscriptionPlanWidget surface="event" /> : null}
          <Sessions />
          <Actors setActivateContributorInlineAdding={setActivateContributorInlineAdding} />
          <Crew />
          <Features />
        </Box>
      </Box>
      <EditSettingsModal
        open={settingsOpen}
        menuSelected={menuSelected}
        setMenuSelected={setMenuSelected}
        close={() => setSettingsOpen(false)}
        initialDayIndex={initialDayIndex}
      />
    </>
  );
};
